import { useEffect, useRef, useState } from 'react'
import { useOnline } from 'utils/hooks/use-online'
import { useConnectionStatusStore } from 'stores/connectionStatusStore'
import type { ConnectionStatusKind } from './types'

export const RECONNECTED_VISIBLE_MS = 4000

export const useConnectionStatus = () => {
  const { isOnline } = useOnline()
  const isSlowConnection = useConnectionStatusStore(
    state => state.slowRequestsCount > 0
  )
  const [showReconnected, setShowReconnected] = useState(false)
  const wasOffline = useRef(!isOnline)

  useEffect(() => {
    if (!isOnline) {
      wasOffline.current = true
      setShowReconnected(false)
      return
    }

    if (!wasOffline.current) {
      return
    }

    wasOffline.current = false
    setShowReconnected(true)

    const timer = setTimeout(
      () => setShowReconnected(false),
      RECONNECTED_VISIBLE_MS
    )

    return () => clearTimeout(timer)
  }, [isOnline])

  const status: ConnectionStatusKind | null = !isOnline
    ? 'offline'
    : showReconnected
    ? 'reconnected'
    : isSlowConnection
    ? 'slow'
    : null

  return { status }
}
